import { Button } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import { useModal } from '../../../components/Utils/UseModal'
import ModalEstornos from './ModalEstornos'

const BotaoEstornos = ({
  codigo,
  idPedidoVenda,
  idAtendimento,
  habilitado,
  temPagamento,
  onTotalEstornado,
}) => {
  const [podeEstornar, setPodeEstornar] = useState(false)
  const modalEstornos = useModal(ModalEstornos)
  const consultarResumo = useCallback(async () => {
    if (!temPagamento || (!idPedidoVenda && !idAtendimento)) return
    const resposta = await metodoPrograma(
      'resumoEstornos',
      { idPedidoVenda, idAtendimento },
      codigo,
    )
    if (resposta.status)
      onTotalEstornado?.(Number(resposta.totalEstornado || 0))
  }, [codigo, idAtendimento, idPedidoVenda, temPagamento])
  const consultar = useCallback(async () => {
    if (!habilitado || !temPagamento || (!idPedidoVenda && !idAtendimento))
      return setPodeEstornar(false)
    const resposta = await metodoPrograma(
      'podeEstornar',
      { idPedidoVenda, idAtendimento },
      codigo,
    )
    setPodeEstornar(Boolean(resposta.status && resposta.podeEstornar))
  }, [
    codigo,
    habilitado,
    idAtendimento,
    idPedidoVenda,
    onTotalEstornado,
    temPagamento,
  ])
  useEffect(() => {
    consultar()
  }, [consultar])
  useEffect(() => {
    consultarResumo()
  }, [consultarResumo])
  if (!podeEstornar) return null
  return (
    <Button
      fullWidth
      sx={{ mt: 1 }}
      color="warning"
      variant="outlined"
      onClick={() =>
        modalEstornos({
          codigo,
          idPedidoVenda,
          idAtendimento,
          onAtualizar: () => {
            consultar()
            consultarResumo()
          },
        })
      }
    >
      Estornar pagamento
    </Button>
  )
}

export default BotaoEstornos
